import { NavItem } from '../../nav/primitives/nav-item';
import { useAnalyticsNavItem } from './use-analytics-nav-item';

export const AnalyticsNavItem = () => {
  const item = useAnalyticsNavItem();
  return <NavItem item={item} />;
};
